import { fork } from "redux-saga/effects";

import authWatcherSaga from "./auth";
import companyWatcherSaga from "./company";
import localStorageWatcherSaga from "./util";
import coworkerWatcherSaga from "./coworker";
import activityWatcherSaga from "./activity";
import migrationWatcherSaga from "./migration";
import connectWatcherSaga from "./connect";
import appsWatcherSaga from "./apps";
export default function* rootSaga() {
  yield fork(authWatcherSaga);
  yield fork(localStorageWatcherSaga);
  yield fork(companyWatcherSaga);
  yield fork(coworkerWatcherSaga);
  yield fork(activityWatcherSaga);
  yield fork(migrationWatcherSaga);
  yield fork(connectWatcherSaga);
  yield fork(appsWatcherSaga);
}
